import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./avatar.css";
import "./file-upload.css";
import "react-tooltip/dist/react-tooltip.css";
import App from "./App";

import { BrowserRouter } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { initSentry, SentryErrorBoundary, reloadOnChunkError } from "./configs/sentry";
import { loadUmami } from "./configs/umami";
import { captureAttribution, getOrCreateVisitorId } from "./services/attribution/attribution";
import { GlobalErrorFallback } from "./components/errors/GlobalErrorFallback";

initSentry();
// Antes de cargar Umami, para que la primera página vista ya lleve su canal.
try {
  captureAttribution(window.location);
} catch (error) {
  // La atribución nunca debe afectar la carga del sitio.
}
loadUmami({ visitorId: getOrCreateVisitorId() });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SentryErrorBoundary fallback={<GlobalErrorFallback />} onError={reloadOnChunkError}>
    <GoogleReCaptchaProvider reCaptchaKey="6Lfh5xwsAAAAADzzsE--IrLEmoWBcCkBkpbYQn5C">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  </SentryErrorBoundary>
);
